const ROUTES = {
  ADMIN_PANEL: '/bo',
  BASENAME: '/fo',
  CONTENT: '/content',
  CATEGORY_CONTENTS: '/contentcategory',
  CHALLENGE: '/challenge',
  DECLARE: '/declare',
  FORM: '/form',
  HISTORY: '/history',
  FORGOT_PASSWORD: '/auth/forgot-password',
  HOME: '/',
  LOGIN: '/auth',
  MFA_CODE_VERIFY: '/auth/mfa-code-verify',
  RESET_PASSWORD: '/auth/reset-password',
  CREATE_NEW_PASSWORD: '/auth/create/password',
  SSO_FAILURE: '/auth/sso-failure',
  SUBSCRIBE: '/auth/subscribe',
  SSO_AZURE_CONNECT: '/v2/connect/azure',
  LINK_EXPIRED: '/auth/link-expired',

  STORE_HOME: '/store',
  STORE_FAVORITE: '/store/wishlist',
  STORE_ACCOUNT: '/account/details',
  STORE_CONTACT: '/account/contact'
} as const;

export default ROUTES;
